const PropTypes = require('prop-types');
const React = require('react');
const OrderCustoms = require('./order_customs');
const Tooltip = require('components/tooltip');
const ErrorMessage = require('components/shared/error_message');

class MultiOrderCustoms extends React.Component {
  get isLoadingCountries() {
    return this.props.originCountries.length === 0;
  }

  get hideForm() {
    if (this.props.needsCustoms) {
      return this.props.orders.length === 0 || this.isLoadingCountries;
    }
    return true;
  }

  showDeclaredValueWarning() {
    if (this.props.aboveMaximumIntlDeclaredValueThreshold) {
      return (
        <div
          className="alert alert-small alert-error mb-0"
          dangerouslySetInnerHTML={{ __html: I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.aboveMaximumAllowedDeclaredValueHtml', { maximumAmount: this.props.maximumDeclaredValue, declaredAmount: this.props.formattedTotalDeclaredValue, lineBreak: '<br>' }) }}
        >
        </div>
      );
    }
    return null;
  }

  showFormErrors() {
    if (this.props.errorMessage) {
      return (
        <ErrorMessage
          message={this.props.errorMessage}
          alertStyle="alert-small alert-error mb-0"
        />
      );
    }
    return null;
  }

  renderOrdersCustoms() {
    return (
      this.props.orders.map((order) =>
        <OrderCustoms
          originCountries={this.props.originCountries}
          order={order}
          key={order.id}
        />
      )
    );
  }

  renderSignatureField() {
    return (
      <div>
        <hr className="mtb-1"></hr>
        <div className="g-container">
          <div className="g-col-6 g-offset-6 g-col-mobile-12 g-offset-mobile-0">
            <label>
              {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.firstAndLastName')}
              <Tooltip
                className="ml-half"
                title={I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.certifyTooltipHtml', { lineBreak: '<br>' })}
              />
            </label>
            <input
              className="string required wide"
              type="text"
              name="shipping_label_form[customs_info][customs_signer]"
            />
            <div className="custom-checkbox">
              <label className="custom-checkbox__label checkbox">
                <input
                  name="shipping_label_form[customs_info][certified]"
                  type="hidden"
                  value="0"
                />
                <input
                  className="required"
                  type="checkbox"
                  value="1"
                  name="shipping_label_form[customs_info][certified]"
                />
                <span className="custom-checkbox__overlay"></span>
                <span className="custom-checkbox__text">
                  {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.certifyAccuracy')}
                </span>
              </label>
            </div>
            {this.showFormErrors()}
            {this.showDeclaredValueWarning()}
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.hideForm) { return null; }

    return (
      <div className="module mb-2">
        <h3 className="heading-3">
          {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.customsTitle')}
        </h3>
        <p
          className="mb-1"
          dangerouslySetInnerHTML={{ __html: I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.customsExplainerHtml', { linkOpen: '<a href="https://about.usps.com/publications/pub141/standard-prohibited-and-restricted-items.htm" target="_blank">', linkClose: '</a>' }) }}
        >
        </p>
        {this.renderOrdersCustoms()}
        {this.renderSignatureField()}
      </div>
    );
  }
}

MultiOrderCustoms.propTypes = {
  orders: PropTypes.array.isRequired,
  originCountries: PropTypes.array.isRequired,
  aboveMaximumIntlDeclaredValueThreshold: PropTypes.bool.isRequired,
  maximumDeclaredValue: PropTypes.string,
  errorMessage: PropTypes.string,
  needsCustoms: PropTypes.bool.isRequired,
  formattedTotalDeclaredValue: PropTypes.string,
};

MultiOrderCustoms.defaultProps = {
  orders: [],
  originCountries: [],
  aboveMaximumIntlDeclaredValueThreshold: false,
  needsCustoms: false,
};

module.exports = MultiOrderCustoms;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/multi_order_customs.jsx